import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {ViewMode} from '../../model/enum/ViewMode';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import StringUtils from '../../utils/StringUtils';
import {Card} from 'primereact/card';
import {t} from 'i18next';

export const DelegationSummaryStep = ({element, validator, initViewMode, handleChange}) => {
    const getSummed = () => {
        let totalValue = 0;
        if (element.summary?.dietRefund) totalValue += element.summary?.dietRefund.value;
        if (element.summary?.localTransportRefund) totalValue += element.summary?.localTransportRefund.value;
        if (element.summary?.accommodationRefund) totalValue += element.summary?.accommodationRefund.value;
        if (element.summary?.otherExpenseRefund) totalValue += element.summary?.otherExpenseRefund.value;
        if (element.summary?.transferRefund) totalValue += element.summary?.transferRefund.value;
        if (element.summary?.vehicleLogRefund) totalValue += element.summary?.vehicleLogRefund.value;
        return totalValue;
    };
    const getTotalSummary = () => {
        return element.summary?.totalRefund ? element.summary?.totalRefund.value : 0;
    };

    const [totalRefund, setTotalRefund] = useState(getTotalSummary());
    const [summedRefund, setSummedRefund] = useState(getSummed());
    const [viewMode, setViewMode] = useState(initViewMode);

    useEffect(() => {
        setViewMode(initViewMode);
    }, [initViewMode]);

    const isForeign = () => {
        return element.type?.enumValue === 'FOREIGN';
    };

    const getValue = (val) => {
        if (StringUtils.isBlank(val)) {
            return 0;
        }
        return val;
    };
    const calculateTotalRefund = () => {
        const summed = getSummed();
        setSummedRefund(summed);
        const advacneValue = element?.advance?.advanceAmount?.value ? element?.advance?.advanceAmount?.value : 0;
        const refundTotal = summed - advacneValue;
        setTotalRefund(refundTotal < 0 ? 0 : refundTotal);
    };

    const renderNumberComponent = (componentEditable, value, label) => {
        return viewMode === ViewMode.VIEW ? (
            <div className='row mb-4'>
                <div className='col-md-6 summary-label'>{label}</div>
                <div className='col-md-6 summary-value'>{StringUtils.isBlank(value) ? 0 : value} zł</div>
            </div>
        ) : (
            componentEditable
        );
    };

    const summaryValueView = viewMode === ViewMode.VIEW ? 'summary-delegation-view' : '';
    return (
        <div className='row justify-content-around m-0 mt-4 mb-4'>
            <Card
                className='data-card  col-6'
                header={() => {
                    return (
                        <div className='card-header-with-icon-container'>
                            <i className='mdi mdi-cash-minus' />
                            <span>Zwroty kosztów</span>
                        </div>
                    );
                }}
            >
                {renderNumberComponent(
                    <InputNumberComponent
                        id={`amount-dietRefund`}
                        name='value'
                        label={'Diety'}
                        value={element.summary?.dietRefund?.value}
                        onChange={handleChange}
                        viewMode={viewMode}
                        showLabel={true}
                        validator={validator}
                        onAfterStateChange={() => calculateTotalRefund()}
                        validators={'not_required'}
                        mode={'currency'}
                        currency='PLN'
                        stateField='element.summary.dietRefund'
                        colClass={`col-12 ${summaryValueView}`}
                        locale='pl-PL'
                    />,
                    element.summary?.dietRefund?.value,
                    'Diety'
                )}
                {renderNumberComponent(
                    <InputNumberComponent
                        id={`amount-localTransportRefund`}
                        name='value'
                        label={'Komunikacja miejska'}
                        value={element.summary?.localTransportRefund?.value}
                        onChange={handleChange}
                        viewMode={viewMode}
                        showLabel={true}
                        validator={validator}
                        onAfterStateChange={() => calculateTotalRefund()}
                        validators={'not_required'}
                        mode={'currency'}
                        currency='PLN'
                        colClass={`col-12 ${summaryValueView}`}
                        locale='pl-PL'
                        stateField='element.summary.localTransportRefund'
                    />,
                    element.summary?.localTransportRefund?.value,
                    'Komunikacja miejska'
                )}

                {renderNumberComponent(
                    <InputNumberComponent
                        id={`amount-accommodationRefund`}
                        name='value'
                        label={'Noclegi'}
                        value={element?.summary?.accommodationRefund?.value}
                        onChange={handleChange}
                        viewMode={viewMode}
                        showLabel={true}
                        validator={validator}
                        onAfterStateChange={() => calculateTotalRefund()}
                        validators={'not_required'}
                        mode={'currency'}
                        currency='PLN'
                        colClass={`col-12 ${summaryValueView}`}
                        locale='pl-PL'
                        stateField='element.summary.accommodationRefund'
                    />,
                    element.summary?.accommodationRefund?.value,
                    'Noclegi'
                )}

                {renderNumberComponent(
                    <InputNumberComponent
                        id={`amount-otherExpenseRefund`}
                        name='value'
                        label={'Inne wydatki'}
                        value={element.summary?.otherExpenseRefund?.value}
                        onChange={handleChange}
                        viewMode={viewMode}
                        showLabel={true}
                        validator={validator}
                        onAfterStateChange={() => calculateTotalRefund()}
                        validators={'not_required'}
                        mode={'currency'}
                        currency='PLN'
                        colClass={`col-12 ${summaryValueView}`}
                        locale='pl-PL'
                        stateField='element.summary.otherExpenseRefund'
                    />,
                    element.summary?.otherExpenseRefund?.value,
                    'Inne wydatki'
                )}
                {renderNumberComponent(
                    <InputNumberComponent
                        id={`amount-transferRefund`}
                        name='value'
                        label={isForeign() ? 'Dojazdy do/z dworca/portu' : 'Przejazdy'}
                        value={element.summary?.transferRefund?.value}
                        onChange={handleChange}
                        viewMode={viewMode}
                        showLabel={true}
                        validator={validator}
                        validators={'not_required'}
                        mode={'currency'}
                        currency='PLN'
                        colClass={`col-12 ${summaryValueView}`}
                        onAfterStateChange={() => calculateTotalRefund()}
                        locale='pl-PL'
                        stateField='element.summary.transferRefund'
                    />,
                    element.summary?.transferRefund?.value,
                    isForeign() ? 'Dojazdy do/z dworca/portu' : 'Przejazdy'
                )}

                {renderNumberComponent(
                    <InputNumberComponent
                        id={`amount-vehicleLogRefund`}
                        name='value'
                        label={'Ewidencja przejazdów pojazdem'}
                        value={element.summary?.vehicleLogRefund?.value}
                        onChange={handleChange}
                        viewMode={viewMode}
                        showLabel={true}
                        validator={validator}
                        validators={'not_required'}
                        mode={'currency'}
                        currency='PLN'
                        colClass={`col-12 ${summaryValueView}`}
                        onAfterStateChange={() => calculateTotalRefund()}
                        locale='pl-PL'
                        stateField='element.summary.vehicleLogRefund'
                    />,
                    element.summary?.vehicleLogRefund?.value,
                    'Ewidencja przejazdów pojazdem'
                )}
            </Card>

            <Card
                className='data-card col-6'
                header={() => {
                    return (
                        <div className='card-header-with-icon-container'>
                            <i className='mdi  mdi-cash-refund' />
                            <span>Suma</span>
                        </div>
                    );
                }}
            >
                {renderNumberComponent(
                    <InputNumberComponent
                        id={`amount-advance`}
                        name='value'
                        label={'Pobrana zaliczka'}
                        value={getValue(element?.advance?.advanceAmount?.value)}
                        onChange={() => {}}
                        viewMode={viewMode}
                        disabled={true}
                        validator={validator}
                        validators={'not_required'}
                        mode={'currency'}
                        currency='PLN'
                        colClass={`col-12 ${summaryValueView}`}
                        locale='pl-PL'
                    />,
                    getValue(element?.advance?.advanceAmount?.value),
                    'Pobrana zaliczka'
                )}
                {renderNumberComponent(
                    <InputNumberComponent
                        id={`amount-summedRefund`}
                        name='value'
                        label={'Koszta'}
                        value={getValue(summedRefund)}
                        onChange={() => {}}
                        viewMode={viewMode}
                        disabled={true}
                        validator={validator}
                        validators={'not_required'}
                        mode={'currency'}
                        currency='PLN'
                        colClass={`col-12 ${summaryValueView}`}
                        locale='pl-PL'
                    />,
                    getValue(summedRefund),
                    'Koszta'
                )}
                {renderNumberComponent(
                    <InputNumberComponent
                        id={`amount-totalRefund`}
                        name='value'
                        label={'Do wypłaty'}
                        value={getValue(totalRefund)}
                        onChange={() => {}}
                        viewMode={viewMode}
                        disabled={true}
                        validator={validator}
                        validators={'not_required'}
                        mode={'currency'}
                        currency='PLN'
                        colClass={`col-12 ${summaryValueView}`}
                        locale='pl-PL'
                    />,
                    getValue(totalRefund),
                    'Do wypłaty'
                )}
            </Card>
        </div>
    );
};

DelegationSummaryStep.defaultProps = {
    handleChange: undefined,
    viewMode: ViewMode.VIEW,
    element: undefined,
    validator: undefined,
};

DelegationSummaryStep.propTypes = {
    handleChange: PropTypes.func.isRequired,
    viewMode: PropTypes.string,
    element: PropTypes.object,
    validator: PropTypes.object,
};

export default DelegationSummaryStep;
